/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Total_ReceivedInputs */

const en_case_payment_total_received = /** @type {(inputs: Case_Payment_Total_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total received`)
};

const pt_br2_case_payment_total_received = /** @type {(inputs: Case_Payment_Total_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total recebido`)
};

/**
* | output |
* | --- |
* | "Total received" |
*
* @param {Case_Payment_Total_ReceivedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_total_received = /** @type {((inputs?: Case_Payment_Total_ReceivedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Total_ReceivedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_total_received(inputs)
	return pt_br2_case_payment_total_received(inputs)
});